import{a as e}from"./chunk-RAAYCPUM.js";function n(...r){return e(Object.fromEntries,r)}export{n as a};
